import type { AppManifest } from '@wix/platform-editor-sdk';
import type { TranslationFunction } from 'i18next';

import { shouldAllowInstallingProfileE3, shouldEnableUnifiedManager } from '../../../../../utils/experiments';
import { getIsEditor3 } from '../../../../util';
import { applicationActions } from '../actions';

type ApplicationActions = NonNullable<AppManifest['pages']>['applicationActions'];

export const getApplicationActions = async (t: TranslationFunction): Promise<ApplicationActions> => {
  const actions = [
    ...((await shouldEnableUnifiedManager())
      ? [applicationActions.getUnifiedManagerAction(t)]
      : [applicationActions.getAddPageAction(t)]),
    applicationActions.viewSiteMembersAction,
    ...(getIsEditor3() && !(await shouldAllowInstallingProfileE3())
      ? []
      : [applicationActions.getOpenMemberPrivacyDashboardAction(t)]),
    // This panel is currently not supported in Editor3
    ...(getIsEditor3() ? [] : [applicationActions.openSignUpSettingsAction]),
    applicationActions.getDeleteMembersAreaAction(t),
  ];

  return { default: actions };
};
